module.exports = require("./brx.d.ts");